import throttle from 'lodash/throttle'

// From Modernizr - Detects animation end event name
export function whichAnimationEvent () {
  let t
  let el = document.createElement('fakeelement')
  let transitions = {
    'animation': 'animationend',
    'OAnimation': 'oAnimationEnd',
    'MozAnimation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd'
  }
  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t]
    }
  }
}
// Recursively parse settings object and create list of all image-like properties
export function getImageUrlsFromSettings (settings) {
  const imagesList = []

  const handler = (key, value) => {
    // if (key === 'thumbUrl' || key === 'logo' || key === 'image' || key === 'bg') {
    if (key === 'logo' || key === 'bg') {
      imagesList.push(value)
    }
  }

  const eachRecursive = (obj) => {
    for (let key in obj) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        eachRecursive(obj[key])
      } else {
        handler(key, obj[key])
      }
    }
  }

  eachRecursive(settings)
  return imagesList
}
// Preloads array of images
export function preloadImages (images) {
  const imagesArray = [...images]
  const preload = () => {
    let img = new Image()
    img.src = imagesArray[0]
    // window.logTiming('image loaded', imagesArray[0])
    img.addEventListener('load', () => {
      imagesArray.shift()
      if (imagesArray.length > 0) {
        preload()
      }
    })
  }

  preload()
}

export function preloadImagesExtended (images, callback) {
  const imagesArray = [...images]
  const preload = () => {
    if (imagesArray.length === 0) return
    const curPack = imagesArray[0]

    const imageDone = (url, successed) => {
    //  console.log('imageDone', url, successed)
      const index = curPack.indexOf(url)
      if (index > -1) curPack.splice(index, 1)
    //  console.log('curPack', curPack)
      if (curPack.length === 0) {
        const packNum = images.length - imagesArray.length
        imagesArray.shift()
        preload()
        callback(packNum)
      }
    }
    for (const url of curPack) {
      const img = new Image()
      img.src = url
      img.addEventListener('load', () => imageDone(url, true))
      img.addEventListener('error', () => imageDone(url, false))
    }
  }

  preload()
}

// Scroll fix that prevents pull-to-refresh on iOS devices
export function scrollFix () {
  let maybePreventPullToRefresh = false

  const touchstartHandler = (e) => {
    if (e.touches.length !== 1) return
    // Pull-to-refresh will only trigger if the scroll begins when the document's Y offset is zero.
    maybePreventPullToRefresh = (window.pageYOffset === 0)
  }
  // To suppress pull-to-refresh it is sufficient to preventDefault the first overscrolling touchmove.
  const touchmoveHandler = (e) => {
    if (maybePreventPullToRefresh) {
      maybePreventPullToRefresh = false
      e.preventDefault()
    }
  }

  document.addEventListener('touchstart', touchstartHandler, false)
  document.addEventListener('touchmove', throttle(touchmoveHandler, 200), false)
}



// WEBPACK FOOTER //
// ./src/utils/templatesUtils.js